import { useIntl } from 'react-intl';

import Heading from '@atlaskit/heading';

import { messages } from './messages';

export const FastshiftCsProfilerPage = () => {
	const { formatMessage } = useIntl();

	return <Heading size="large">{formatMessage(messages.pageHeading)}</Heading>;
};
